import * as React from 'react';
import type { SelectMap } from '../../../Utilities/SelectMap';
import { MultiSelectModal } from './MultiSelectModal';

export interface IndUpcomingBirthdaySelectProps {
  userAccessToken: string;
  userId: number;
  disabled?: boolean;

  onChange?: (ranges: Array<string>) => void;

  value: Array<string>;
}

const UPCOMING_BIRTHDAY_INTERVALS: Array<SelectMap> = [
  {
    value: 1,
    label: '1 Month Before Birthday',
  },
  {
    value: 3,
    label: '3 Months Before Birthday',
  },
  {
    value: 6,
    label: '6 Months Before Birthday',
  },
];

export const IndUpcomingBirthdaySelect = (
  props: IndUpcomingBirthdaySelectProps
): React.JSX.Element => {
  const [value, setValue] = React.useState<Array<string>>(props.value);

  return (
    <>
      <div>
        <MultiSelectModal
          disabled={props.disabled}
          value={value}
          options={UPCOMING_BIRTHDAY_INTERVALS}
          modalSaveButtonLabel="Save Changes"
          modalTitle="Select"
          buttonSelectLabel="Choose"
          buttonEditLabel="Edit"
          onChange={(newValue) => {
            setValue(newValue);

            if (props.onChange) {
              props.onChange(newValue);
            }
          }}
        />
      </div>
    </>
  );
};
